// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './App.css';
import reportWebVitals from "./reportWebVitals";

import { AuthProvider } from "./auth/AuthContext";
import AppRouter from "./router";

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();